import { checkIfMobile } from '../services/screen';
import muvikaAttrs from './../attrs';
import { getOS } from './os';
import { Capacitor } from '@capacitor/core';

const setDefaultValues = () => {
  sessionStorage.setItem(muvikaAttrs.service + "-mobile", JSON.stringify(checkIfMobile()));
  sessionStorage.setItem(muvikaAttrs.service + "-platform", JSON.stringify(Capacitor.isNativePlatform() ? Capacitor.getPlatform() : getOS()));
};

export const saveSystemData = () => {
  try {
    if (window.navigator) {
      if (window.navigator.userAgentData) {
        if (window.navigator.userAgentData.getHighEntropyValues) {
          window.navigator.userAgentData.getHighEntropyValues([
            "platform",
            "mobile"
          ]).then(results => {
            if (results.mobile !== null) {
              sessionStorage.setItem(muvikaAttrs.service + "-mobile", JSON.stringify(results.mobile));
            } else {
              sessionStorage.setItem(muvikaAttrs.service + "-mobile", JSON.stringify(checkIfMobile()));
            }
            if (results.platform) {
              sessionStorage.setItem(muvikaAttrs.service + "-platform", JSON.stringify(results.platform));
            } else {
              sessionStorage.setItem(muvikaAttrs.service + "-platform", JSON.stringify(Capacitor.isNativePlatform() ? Capacitor.getPlatform() : getOS()));
            }
          })
            .catch(() => {
              setDefaultValues();
            });
        } else {
          setDefaultValues();
        }
      } else {
        setDefaultValues();
      }
    } else {
      setDefaultValues();
    }
  } catch (err) {
    setDefaultValues();
  }
};
